export const OOF_ITEM_CLASS_REGEX: RegExp = /ipm.note.rules.ooftemplate.microsoft/i;
export const PROACTIVE_DRAFT_HEURISTIC_SCORE_SET_ID = "41F28F13-83F4-4114-A584-EEDB5A6B0BFF";
